import { render, staticRenderFns } from "./QuickTipsSearchId.vue?vue&type=template&id=059bc1e4&scoped=true&"
import script from "./QuickTipsSearchId.vue?vue&type=script&lang=js&"
export * from "./QuickTipsSearchId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059bc1e4",
  null
  
)

export default component.exports